document.title = document.title
  .replace(/\s*[|-]\s*(cuppa|prosendrgolf|axion swing)/ig, ' | GOLF BAIJIA')
  .replace(/^(cuppa|prosendrgolf|axion swing)$/i, 'GOLF BAIJIA');

document.addEventListener('DOMContentLoaded', function () {
  function rebrandText(value) {
    return value
      .replace(/AXION\s+SWINGT?/gi, 'GOLF BAIJIA')
      .replace(/ProSENDR\s+Golf/gi, 'GOLF BAIJIA')
      .replace(/ProSENDR/gi, 'GOLF BAIJIA')
      .replace(/SwingAxis/gi, 'GOLF BAIJIA')
      .replace(/\bAXION\b/gi, 'GOLF BAIJIA');
  }

  function cleanVisibleBrandText() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|SELECT|OPTION)$/i.test(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return /(AXION|ProSENDR|SwingAxis)/i.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      node.nodeValue = rebrandText(node.nodeValue);
    });

    document.querySelectorAll('[alt], [title], [aria-label], [placeholder]').forEach(function (element) {
      ['alt', 'title', 'aria-label', 'placeholder'].forEach(function (attr) {
        var value = element.getAttribute(attr);
        if (value && /(AXION|ProSENDR|SwingAxis)/i.test(value)) {
          element.setAttribute(attr, rebrandText(value));
        }
      });
    });
  }

  cleanVisibleBrandText();

  var toggle = document.querySelector('[data-ps-mobile-toggle]');
  var drawer = document.querySelector('[data-ps-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      drawer.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('.ax-nav a, .ax-drawer a').forEach(function (link) {
    if (link.textContent.trim().toLowerCase().indexOf('shop') >= 0) {
      link.setAttribute('href', '/collections/shop');
    }
    if (link.textContent.trim().toLowerCase().indexOf('contact') >= 0 || link.textContent.trim().toLowerCase().indexOf('cantact') >= 0) {
      link.setAttribute('href', '/policies/contact-information');
      link.textContent = 'Contact';
    }
  });

  var lightbox = null;
  var lightboxImg = null;
  var lightboxCaption = null;
  var lightboxCurrentGallery = null;

  function ensureLightbox() {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'ax-lightbox';
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = [
      '<button type="button" class="ax-lightbox__close" data-ax-lightbox-close aria-label="Close image preview">x</button>',
      '<button type="button" class="ax-lightbox__arrow ax-lightbox__arrow--prev" data-ax-lightbox-prev aria-label="Previous image">&lt;</button>',
      '<figure class="ax-lightbox__figure">',
      '<img class="ax-lightbox__img" alt="">',
      '<figcaption class="ax-lightbox__caption"></figcaption>',
      '</figure>',
      '<button type="button" class="ax-lightbox__arrow ax-lightbox__arrow--next" data-ax-lightbox-next aria-label="Next image">&gt;</button>'
    ].join('');
    document.body.appendChild(lightbox);
    lightboxImg = lightbox.querySelector('.ax-lightbox__img');
    lightboxCaption = lightbox.querySelector('.ax-lightbox__caption');

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.hasAttribute('data-ax-lightbox-close')) closeLightbox();
    });
    lightbox.querySelector('[data-ax-lightbox-prev]').addEventListener('click', function () {
      if (lightboxCurrentGallery && lightboxCurrentGallery.axMoveImage) lightboxCurrentGallery.axMoveImage(-1, true);
    });
    lightbox.querySelector('[data-ax-lightbox-next]').addEventListener('click', function () {
      if (lightboxCurrentGallery && lightboxCurrentGallery.axMoveImage) lightboxCurrentGallery.axMoveImage(1, true);
    });
    document.addEventListener('keydown', function (event) {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft' && lightboxCurrentGallery && lightboxCurrentGallery.axMoveImage) lightboxCurrentGallery.axMoveImage(-1, true);
      if (event.key === 'ArrowRight' && lightboxCurrentGallery && lightboxCurrentGallery.axMoveImage) lightboxCurrentGallery.axMoveImage(1, true);
    });
    return lightbox;
  }

  function openLightbox(gallery, src, alt) {
    ensureLightbox();
    lightboxCurrentGallery = gallery;
    lightboxImg.src = src || '';
    lightboxImg.alt = alt || '';
    lightboxCaption.textContent = alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ax-lightbox-open');
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ax-lightbox-open');
    window.setTimeout(function () {
      if (!lightbox.classList.contains('is-open')) {
        lightboxImg.removeAttribute('src');
        lightboxCurrentGallery = null;
      }
    }, 180);
  }

  function syncLightbox(src, alt) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    lightboxImg.src = src || '';
    lightboxImg.alt = alt || '';
    lightboxCaption.textContent = alt || '';
  }

  function setupGallery(gallery) {
    var main = gallery.querySelector('[data-ps-main-image]');
    var mainWrap = main && main.closest('.ax-main-img, .ps-main-img');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ps-thumb]'));
    if (!main || !mainWrap || !thumbs.length) return;

    var activeIndex = Math.max(0, thumbs.findIndex(function (btn) {
      return btn.classList.contains('is-active');
    }));
    var locked = false;
    var touchStartX = 0;
    var touchStartY = 0;

    function thumbData(index) {
      var btn = thumbs[index];
      if (!btn) return null;
      return {
        src: btn.getAttribute('data-src'),
        alt: btn.getAttribute('data-alt') || '',
        button: btn
      };
    }

    function updateThumbScroll(btn) {
      if (!btn || !btn.scrollIntoView) return;
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    function setActive(index, direction) {
      if (locked || index === activeIndex || index < 0 || index >= thumbs.length) return;
      var data = thumbData(index);
      if (!data || !data.src) return;
      locked = true;
      mainWrap.classList.remove('is-sliding-next', 'is-sliding-prev');
      mainWrap.classList.add(direction === 'prev' ? 'is-sliding-prev' : 'is-sliding-next');

      window.setTimeout(function () {
        main.src = data.src;
        main.alt = data.alt;
        syncLightbox(data.src, data.alt);
        thumbs.forEach(function (btn) { btn.classList.remove('is-active'); });
        data.button.classList.add('is-active');
        activeIndex = index;
        updateThumbScroll(data.button);
        window.requestAnimationFrame(function () {
          mainWrap.classList.remove('is-sliding-next', 'is-sliding-prev');
          window.setTimeout(function () { locked = false; }, 240);
        });
      }, 130);
    }

    function move(delta) {
      var next = activeIndex + delta;
      if (next < 0) next = thumbs.length - 1;
      if (next >= thumbs.length) next = 0;
      setActive(next, delta < 0 ? 'prev' : 'next');
    }

    gallery.axMoveImage = move;
    gallery.axOpenZoom = function () {
      var data = thumbData(activeIndex);
      openLightbox(gallery, (data && data.src) || main.src, (data && data.alt) || main.alt || '');
    };

    thumbs.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        setActive(index, index < activeIndex ? 'prev' : 'next');
      });
    });

    if (thumbs.length > 1 && !mainWrap.querySelector('[data-ax-gallery-prev]')) {
      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = 'button';
      next.type = 'button';
      prev.className = 'ax-gallery-arrow ax-gallery-arrow--prev';
      next.className = 'ax-gallery-arrow ax-gallery-arrow--next';
      prev.setAttribute('aria-label', 'Previous product image');
      next.setAttribute('aria-label', 'Next product image');
      prev.setAttribute('data-ax-gallery-prev', '');
      next.setAttribute('data-ax-gallery-next', '');
      prev.innerHTML = '&lt;';
      next.innerHTML = '&gt;';
      mainWrap.appendChild(prev);
      mainWrap.appendChild(next);
      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
    }

    mainWrap.addEventListener('touchstart', function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });

    mainWrap.addEventListener('touchend', function (event) {
      if (!event.changedTouches || event.changedTouches.length !== 1) return;
      var dx = event.changedTouches[0].clientX - touchStartX;
      var dy = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        move(dx > 0 ? -1 : 1);
      }
    }, { passive: true });

    mainWrap.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.ax-gallery-arrow')) return;
      gallery.axOpenZoom();
    });
    mainWrap.setAttribute('role', 'button');
    mainWrap.setAttribute('tabindex', '0');
    mainWrap.setAttribute('aria-label', 'Open larger product image');
    mainWrap.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        gallery.axOpenZoom();
      }
    });

    gallery.axSetImageBySrc = function (src) {
      var matchIndex = thumbs.findIndex(function (btn) {
        return btn.getAttribute('data-src') === src;
      });
      if (matchIndex >= 0) {
        setActive(matchIndex, matchIndex < activeIndex ? 'prev' : 'next');
      } else if (src) {
        mainWrap.classList.add('is-sliding-next');
        window.setTimeout(function () {
          main.src = src;
          syncLightbox(src, main.alt || '');
          window.requestAnimationFrame(function () {
            mainWrap.classList.remove('is-sliding-next');
          });
        }, 130);
      }
    };
  }

  document.querySelectorAll('[data-ps-gallery]').forEach(setupGallery);

  document.querySelectorAll('.ax-product-use-photo--scroll').forEach(function (frame) {
    var dragging = false;
    var startY = 0;
    var startScroll = 0;

    frame.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      dragging = true;
      startY = event.pageY;
      startScroll = frame.scrollTop;
      frame.classList.add('is-dragging');
      event.preventDefault();
    });

    window.addEventListener('mousemove', function (event) {
      if (!dragging) return;
      frame.scrollTop = startScroll - (event.pageY - startY);
    });

    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      frame.classList.remove('is-dragging');
    });
  });

  function formatStoreMoney(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function getVariantDiscount(priceCents, compareCents) {
    if (!compareCents || compareCents <= priceCents) return '';
    return String(Math.floor(((compareCents - priceCents) * 100) / compareCents));
  }

  function renderSyncedPrice(priceCents, compareCents) {
    var html = '<span>' + formatStoreMoney(priceCents) + '</span>';
    var discount = getVariantDiscount(priceCents, compareCents);
    if (discount) {
      html += '<s>' + formatStoreMoney(compareCents) + '</s><b>Save ' + discount + '%</b>';
    }
    return html;
  }

  function updateProductPriceContainer(container, variant) {
    if (!container || !variant) return;
    container.innerHTML = renderSyncedPrice(variant.price, variant.compare_at_price);
  }

  function productHandleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  var productJsonCache = {};

  function fetchProductJson(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (!productJsonCache[handle]) {
      productJsonCache[handle] = fetch('/products/' + handle + '.js?codex_price_sync=' + Date.now(), {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error('Price sync failed for ' + handle);
        return response.json();
      });
    }
    return productJsonCache[handle];
  }

  function syncProductPagePrices() {
    var handle = productHandleFromUrl(window.location.pathname);
    if (!handle) return;
    fetchProductJson(handle).then(function (productJson) {
      var variants = {};
      (productJson.variants || []).forEach(function (variant) {
        variants[String(variant.id)] = variant;
      });

      document.querySelectorAll('[data-variant-select]').forEach(function (select) {
        Array.prototype.forEach.call(select.options, function (option) {
          var variant = variants[String(option.value)];
          if (!variant) return;
          var discount = getVariantDiscount(variant.price, variant.compare_at_price);
          option.dataset.price = formatStoreMoney(variant.price);
          option.dataset.comparePrice = variant.compare_at_price ? formatStoreMoney(variant.compare_at_price) : '';
          option.dataset.hasDiscount = discount ? 'true' : 'false';
          option.dataset.discount = discount;
        });
      });

      var idInput = document.querySelector('form input[name="id"]');
      var selected = document.querySelector('[data-variant-select]');
      var selectedId = selected ? selected.value : (idInput && idInput.value);
      updateProductPriceContainer(document.querySelector('[data-variant-price]'), variants[String(selectedId)] || productJson.variants[0]);
    }).catch(function () {});
  }

  function syncProductCardPrices() {
    var cardsByHandle = {};
    document.querySelectorAll('a.ps-product-card[href*="/products/"], a.ax-product-card[href*="/products/"], [data-product-card][href*="/products/"]').forEach(function (card) {
      var handle = productHandleFromUrl(card.getAttribute('href'));
      if (!handle) return;
      cardsByHandle[handle] = cardsByHandle[handle] || [];
      cardsByHandle[handle].push(card);
    });

    Object.keys(cardsByHandle).forEach(function (handle) {
      fetchProductJson(handle).then(function (productJson) {
        var variant = (productJson.variants || []).filter(function (item) {
          return item.available;
        })[0] || (productJson.variants || [])[0];
        if (!variant) return;
        cardsByHandle[handle].forEach(function (card) {
          var price = card.querySelector('.ps-product-card__price, .ax-price');
          if (!price) return;
          var discount = getVariantDiscount(variant.price, variant.compare_at_price);
          if (price.classList.contains('ax-price')) {
            price.innerHTML = '<span>' + formatStoreMoney(variant.price) + '</span>' +
              (discount ? '<s>' + formatStoreMoney(variant.compare_at_price) + '</s>' : '');
            var badge = card.querySelector('.ax-save-badge');
            if (!badge && discount) {
              var media = card.querySelector('.ax-product-card__media');
              badge = document.createElement('span');
              badge.className = 'ax-save-badge';
              if (media) media.appendChild(badge);
            }
            if (badge) {
              badge.textContent = discount ? 'Save ' + discount + '%' : '';
              badge.hidden = !discount;
            }
          } else {
            price.innerHTML = '<span class="ps-sale-price">' + formatStoreMoney(variant.price) + '</span>' +
              (discount ? '<span class="ps-compare-price">' + formatStoreMoney(variant.compare_at_price) + '</span><span class="ps-discount-badge">Save ' + discount + '%</span>' : '');
          }
        });
      }).catch(function () {});
    });
  }

  syncProductPagePrices();
  syncProductCardPrices();

  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      var price = form && form.querySelector('[data-variant-price]');
      var img = opt.getAttribute('data-image');
      var idInput = form && form.querySelector('input[name="id"]');
      if (idInput) idInput.value = sel.value;
      if (price && opt.dataset.price) {
        var html = '<span>' + opt.dataset.price + '</span>';
        if (opt.dataset.hasDiscount === 'true') {
          html += '<s>' + opt.dataset.comparePrice + '</s><b>Save ' + opt.dataset.discount + '%</b>';
        }
        price.innerHTML = html;
      }
      if (img) {
        var gallery = document.querySelector('[data-ps-gallery]');
        if (gallery && gallery.axSetImageBySrc) {
          gallery.axSetImageBySrc(img);
        } else {
          var main = document.querySelector('[data-ps-main-image]');
          if (main) main.src = img;
        }
      }
    });
  });

  function applyProductFilters() {
    var input = document.querySelector('[data-ps-filter]');
    var activeButton = document.querySelector('[data-ax-goal-filter] button.is-active');
    var q = input ? input.value.toLowerCase().trim() : '';
    var goal = activeButton ? activeButton.getAttribute('data-goal') : 'all';
    document.querySelectorAll('[data-product-card]').forEach(function (card) {
      var text = card.textContent.toLowerCase();
      var goalText = (card.getAttribute('data-goal') || '').toLowerCase();
      var titleText = (card.getAttribute('data-product-title') || '').toLowerCase();
      var matchesSearch = !q || text.indexOf(q) >= 0 || titleText.indexOf(q) >= 0;
      var matchesGoal = goal === 'all' || goalText.indexOf(goal) >= 0 || titleText.indexOf(goal) >= 0 || text.indexOf(goal) >= 0;
      card.style.display = matchesSearch && matchesGoal ? 'block' : 'none';
    });
  }

  function syncVisibleFilterButtons() {
    document.querySelectorAll('[data-ax-goal-filter]').forEach(function (group) {
      var goals = {};
      document.querySelectorAll('[data-product-card]').forEach(function (card) {
        (card.getAttribute('data-goal') || '').toLowerCase().split(/\s+/).forEach(function (goal) {
          if (goal) goals[goal] = true;
        });
      });
      group.querySelectorAll('button').forEach(function (button) {
        var goal = button.getAttribute('data-goal');
        if (goal && goal !== 'all' && !goals[goal]) {
          button.hidden = true;
          button.classList.remove('is-active');
        } else {
          button.hidden = false;
        }
      });
      if (!group.querySelector('button.is-active')) {
        var allButton = group.querySelector('button[data-goal="all"]');
        if (allButton) allButton.classList.add('is-active');
      }
    });
  }

  document.querySelectorAll('[data-ps-filter]').forEach(function (input) {
    input.addEventListener('input', applyProductFilters);
  });

  document.querySelectorAll('[data-ax-goal-filter] button').forEach(function (button) {
    button.addEventListener('click', function () {
      var group = button.closest('[data-ax-goal-filter]');
      group.querySelectorAll('button').forEach(function (btn) { btn.classList.remove('is-active'); });
      button.classList.add('is-active');
      applyProductFilters();
    });
  });

  syncVisibleFilterButtons();
  applyProductFilters();

  function rotationTrainerVideoFix() {
    if (window.location.pathname.indexOf('/products/swing-rotation-trainer-golf-hip-turn-power-transfer-training-aid') === -1 && window.location.pathname.indexOf('/products/golf-baijia-swing-rotation-trainer') === -1) {
      return;
    }
    var fixedSrc = 'https://cdn.shopify.com/s/files/1/0709/7443/9578/t/5/assets/golf-baijia-swing-rotation-trainer-en-h264.mp4?v=1784188251';
    document.querySelectorAll('video').forEach(function (video) {
      var changed = false;
      video.querySelectorAll('source').forEach(function (source) {
        var src = source.getAttribute('src') || '';
        if (src.indexOf('golf-baijia-swing-rotation-trainer-en') !== -1 && src.indexOf('-h264') === -1) {
          source.setAttribute('src', fixedSrc);
          changed = true;
        }
      });
      if (changed) {
        video.load();
      }
    });
  }

  function speedTrainerVideoFix() {
    if (window.location.pathname.indexOf('/products/golf-swing-speed-trainer-adjustable-clubhead-speed-training-aid') === -1) {
      return;
    }
    var fixedSrc = 'https://cdn.shopify.com/s/files/1/0709/7443/9578/t/5/assets/golf-baijia-swing-speed-trainer-en-clean-h264.mp4?v=1784193118';
    document.querySelectorAll('video').forEach(function (video) {
      var changed = false;
      video.querySelectorAll('source').forEach(function (source) {
        var src = source.getAttribute('src') || '';
        if (src.indexOf('golf-baijia-swing-speed-trainer-en') !== -1 && src !== fixedSrc) {
          source.setAttribute('src', fixedSrc);
          changed = true;
        }
      });
      if (changed) {
        video.load();
      }
    });
  }

  function normalizePrivacyPolicyContact() {
    if (window.location.pathname.indexOf('/policies/privacy-policy') === -1) {
      return;
    }
    var policyBody = document.querySelector('.shopify-policy__body') || document.querySelector('#MainContent');
    if (!policyBody) return;
    policyBody.innerHTML = policyBody.innerHTML
      .replace(/3310a Rivers Avenue,?\s*North Charleston\s*SC\s*29405,?\s*United States/gi, '6200 Tollbridge Rd, Belton, TX 76513, United States')
      .replace(/prosendrgolf/gi, 'GOLF BAIJIA')
      .replace(/szerbinpessolano5439@outlook\.com/gi, 'SzerbinPessolano5439@outlook.com');
  }

  rotationTrainerVideoFix();
  speedTrainerVideoFix();
  normalizePrivacyPolicyContact();
});

(function () {
  function initParProduct(section) {
    if (!section || section.dataset.parReady === 'true') return;
    section.dataset.parReady = 'true';

    var mainImage = section.querySelector('[data-par-main-image]');
    var thumbs = section.querySelectorAll('[data-par-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var nextImage = thumb.getAttribute('data-image');
        if (!nextImage || !mainImage) return;
        mainImage.src = nextImage;
        mainImage.alt = thumb.getAttribute('data-alt') || mainImage.alt || '';
        thumbs.forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var variantSelect = section.querySelector('[data-par-variant-select]');
    var variantInput = section.querySelector('[data-par-variant-id]');
    var price = section.querySelector('[data-par-price]');
    var compare = section.querySelector('[data-par-compare]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        if (!option) return;
        if (variantInput) variantInput.value = option.value;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (compare) {
          if (option.dataset.comparePrice) {
            compare.textContent = option.dataset.comparePrice;
            compare.classList.remove('is-hidden');
          } else {
            compare.textContent = '';
            compare.classList.add('is-hidden');
          }
        }
      });
    }

    var qtyInput = section.querySelector('[data-par-qty-input]');
    var minus = section.querySelector('[data-par-qty-minus]');
    var plus = section.querySelector('[data-par-qty-plus]');
    function setQty(nextValue) {
      if (!qtyInput) return;
      var value = parseInt(nextValue, 10);
      if (!Number.isFinite(value) || value < 1) value = 1;
      qtyInput.value = value;
    }
    if (minus) {
      minus.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        setQty((parseInt(qtyInput.value, 10) || 1) + 1);
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });
    }

    var videoTrigger = section.querySelector('[data-par-video-trigger]');
    var videoModal = section.querySelector('[data-par-video-modal]');
    var videoClose = section.querySelector('[data-par-video-close]');
    var video = videoModal ? videoModal.querySelector('video') : null;
    function closeVideo() {
      if (!videoModal) return;
      videoModal.hidden = true;
      if (video) video.pause();
    }
    if (videoTrigger && videoModal) {
      videoTrigger.addEventListener('click', function () {
        videoModal.hidden = false;
        if (video) video.play().catch(function () {});
      });
    }
    if (videoClose) videoClose.addEventListener('click', closeVideo);
    if (videoModal) {
      videoModal.addEventListener('click', function (event) {
        if (event.target === videoModal) closeVideo();
      });
    }
  }

  function initAllParProducts() {
    document.querySelectorAll('[data-par-product-section]').forEach(initParProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllParProducts);
  } else {
    initAllParProducts();
  }
  document.addEventListener('shopify:section:load', function (event) {
    initParProduct(event.target.querySelector('[data-par-product-section]'));
  });
})();
